module.exports = __webpack_public_path__ + "img/login-bg.d7a9b7f1.png";